import React from "react";

const CheckIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 9 9"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.75 0H8.25C8.44891 0 8.63968 0.0790176 8.78033 0.21967C8.92098 0.360322 9 0.551088 9 0.75V8.25C9 8.44891 8.92098 8.63968 8.78033 8.78033C8.63968 8.92098 8.44891 9 8.25 9H0.75C0.551088 9 0.360322 8.92098 0.21967 8.78033C0.0790176 8.63968 0 8.44891 0 8.25V0.75C0 0.551088 0.0790176 0.360322 0.21967 0.21967C0.360322 0.0790176 0.551088 0 0.75 0ZM2.60499 4.66102L3.85611 6.05268L7.39501 2.11628C7.42773 2.07944 7.46669 2.0502 7.50965 2.03024C7.5526 2.01028 7.59869 2 7.64524 2C7.69179 2 7.73788 2.01028 7.78083 2.03024C7.82378 2.0502 7.86275 2.07944 7.89546 2.11628C7.92858 2.15267 7.95487 2.19601 7.97282 2.24379C7.99076 2.29157 8 2.34283 8 2.39461C8 2.44639 7.99076 2.49765 7.97282 2.54543C7.95487 2.59321 7.92858 2.63655 7.89546 2.67294L4.10634 6.8837C3.96693 7.03877 3.74172 7.03877 3.60231 6.8837L2.10454 5.21769C2.07142 5.18129 2.04513 5.13795 2.02718 5.09018C2.00924 5.0424 2 4.99113 2 4.93935C2 4.88757 2.00924 4.83631 2.02718 4.78853C2.04513 4.74075 2.07142 4.69741 2.10454 4.66102C2.13725 4.62419 2.17622 4.59494 2.21917 4.57498C2.26212 4.55502 2.30821 4.54474 2.35476 4.54474C2.40131 4.54474 2.4474 4.55502 2.49035 4.57498C2.53331 4.59494 2.57227 4.62419 2.60499 4.66102Z"
    />
  </svg>
);

export default CheckIcon;
